import Styled from 'styled-components'


export const Container = Styled.div`
margin-top: 20px;
margin: 0 2%;

margin-bottom: 30px;

@media(max-width: 800px) {
  margin: 0 5%;
}

`

export const H1 = Styled.h1`
text-align: center;
color: #0b3275;
font-weight: bold;
font-size: 34px;
margin-top: 40px;
margin-bottom: 40px;
`


export const Content = Styled.p`
font-size: 1rem;
text-align: justify;
text-justify: inter-word;
`

export const Strong = Styled.strong`
font-size: 1.2rem;
`

export const TitleProduct = Styled.p`
 margin-top: 10px;
 font-weight: bold;
 margin-top: 50px;
`